enum PfmTimeFrame {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
}

export default PfmTimeFrame;
